exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-feature[data-v-e905d146] {\n  height: 600px;\n}\n.page-block__inner[data-v-e905d146] {\n  text-align: center;\n  font-weight: 400;\n}\n.page-block div[data-v-e905d146] {\n  padding: 10px 30px;\n}\n.page-block ul[data-v-e905d146], .page-block li[data-v-e905d146] {\n  list-style: unset !important;\n}\n.list-container[data-v-e905d146]{\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  text-align: start;\n  margin: auto;\n  padding: 14px 0;\n}\n", ""]);

// exports
